import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

const toastOptions = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  style: {
    zIndex: 999999,
  },
};

export const showSuccessToast = (message) => {
  toast.success(message, {
    ...toastOptions,
  });
};

export const showErrorToast = (message) => {
  toast.error(message, {
    ...toastOptions,
  });
};

export const showInfoToast = (message) => {
  toast.info(message, {
    ...toastOptions,
  });
};

export const showWarningToast = (message) => {
  toast.warn(message, {
    ...toastOptions,
  });
};